import { DelaySettings } from "./DelaySettings";
import { CommunicationSettings } from "./CommunicationSettings";
import { AnalysisNodeSettings } from "./AnalysisNodeSettings";
import { TriggerNodeSettings } from "./TriggerNodeSettings";
import { AssistantNodeSettings } from "./AssistantNodeSettings";
import { EndNodeSettings } from "./EndNodeSettings";

export const NODE_SETTINGS = {
  delay: (props) => <DelaySettings {...props} />,
  communication: CommunicationSettings,
  analysis: AnalysisNodeSettings,
  trigger: TriggerNodeSettings,
  assistant: (props) => <AssistantNodeSettings {...props} />,
  end: EndNodeSettings,
};
